import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FlowShell } from './components/flow-shell';
import { TrackStep } from './components/track-step';
import { FreelancerFlow } from './freelancer';
import { BusinessFlow } from './business';
import { TRACKS } from './data';

/**
 * Entry point for agency creation. Picks a track, then hands off to the
 * matching self-contained flow. A resumed registration skips straight into its
 * flow, which rehydrates from the saved record.
 */
export const CreateAgency = ({ onCreated = () => {} }) => {
  const existing_agency = useSelector((state) => state.metadata.agency);
  const resumed_track = existing_agency && existing_agency.id ? existing_agency.track : '';

  const [track, setTrack] = useState(resumed_track || '');
  const [confirmed, setConfirmed] = useState(!!resumed_track);

  const backToTrack = () => setConfirmed(false);

  if (confirmed && track === 'freelancer') {
    return <FreelancerFlow onCreated={onCreated} onBack={backToTrack} />;
  }
  if (confirmed && track === 'business') {
    return <BusinessFlow onCreated={onCreated} onBack={backToTrack} />;
  }

  return (
    <FlowShell
      title="Create your agency"
      subtitle="Choose how you want to partner with Go-Mailer."
      backDisabled
      primaryLabel="Continue →"
      onPrimary={() => track && setConfirmed(true)}
      primaryDisabled={!track}
    >
      <TrackStep tracks={TRACKS} value={track} onSelect={setTrack} />
    </FlowShell>
  );
};
